import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PochtaTariffDeliveryTimeDto } from './PochtaTariffDeliveryTimeDto'
import { PochtaTariffRatePartDto } from './PochtaTariffRatePartDto'
/**
* Class PochtaTariffDto
*  Ответ ПР без Extra*.
*/
export class PochtaTariffDto extends ActiveModel {

  /**
  * ['total-rate']
  *   */
  @ActiveField()
  ['total-rate']?: null | number


  /**
  * ['total-vat']
  *   */
  @ActiveField()
  ['total-vat']?: null | number


  /**
  * ['delivery-time']
  *   */
  @ActiveField({
    factory: [PochtaTariffDeliveryTimeDto, () => undefined]
  })
  ['delivery-time']?: null | PochtaTariffDeliveryTimeDto


  /**
  * ['ground-rate']
  *   */
  @ActiveField({
    factory: [PochtaTariffRatePartDto, () => undefined]
  })
  ['ground-rate']?: null | PochtaTariffRatePartDto


/**
  * ['payment-method']
  * 
  */
  @ActiveField()
  ['payment-method']?: null | string
}
